// // ========================== SIDEBAR ROUTES ==========================
// // These are the routes shown in the sidebar
// // ====================================================================
// // import { Icon } from '@chakra-ui/react';
// import {
//   MdHome,
//   MdLeaderboard,
//   MdOutlineLaptopMac,
//   MdInsertChartOutlined,
//   MdOutlineAdminPanelSettings,
//   MdPeopleOutline,
//   MdCampaign,
//   MdInsights,
//   MdOutlinePayments,
// } from "react-icons/md";
// import {
//   FaTasks,
//   FaRegCalendarCheck,
//   FaList,
//   FaWhatsapp,
//   FaHandshake,
//   FaPhone,
//   FaRegCopy,
//   FaFileAlt,
//   FaFileInvoiceDollar,
//   FaMoneyCheckAlt,
// } from "react-icons/fa";
// import { HiOutlineDocumentReport, HiUsers } from "react-icons/hi";
// import { FaClipboardUser, FaSquarePlus } from "react-icons/fa6";

// // const sidebarRoutes = [
// // 	// -------- Dashboard --------
// // 	{
// // 		// moduleId: 'dashboard',
// // 		name: 'Dashboard',
// // 		path: '/default',
// // 		icon: <Icon as={MdHome} w='20px' h='20px' />,
// // 	},

// // 	// -------- Leads --------
// // 	{
// // 		moduleId: 'leads',
// // 		name: 'Lead',
// // 		path: '/lead',
// // 		icon: <Icon as={MdLeaderboard} w='20px' h='20px' />,
// // 	},
// // 	{
// // 		moduleId: 'leadpool_admin',
// // 		name: 'Lead Pool',
// // 		path: '/pool',
// // 		icon: <Icon as={MdOutlineAdminPanelSettings} w='20px' h='20px' />,
// // 	},
// // 	{
// // 		moduleId: 'leadpool_agents',
// // 		name: 'Lead Pool',
// // 		path: '/agent_pool',
// // 		icon: <Icon as={MdPeopleOutline} w='20px' h='20px' />,
// // 	},

// // 	// -------- Deals --------
// // 	{
// // 		moduleId: 'deal',
// // 		name: 'Deals',
// // 		path: '/deals',
// // 		icon: <Icon as={FaHandshake} w='20px' h='20px' />,
// // 	},

// // 	// ------- Announcement ------
// // 	{
// // 		moduleId: 'announcement',
// // 		name: 'Announcement',
// // 		path: '/announcements',
// // 		icon: <Icon as={MdCampaign} width='20px' height='20px' color='inherit' />,
// // 	},

// // 	// -------- Hiring --------
// // 	{
// // 		moduleId: 'hiring',
// // 		name: 'Hiring',
// // 		path: '/hiring',
// // 		icon: <Icon as={FaClipboardUser} w='20px' h='20px' />,
// // 	},

// // 	// -------- Attendance --------
// // 	{
// // 		moduleId: 'attendance',
// // 		name: 'Attendance',
// // 		path: '/attendance',
// // 		icon: <Icon as={FaRegCalendarCheck} w='20px' h='20px' />,
// // 	},

// // 	// -------- Invoices --------
// // 	{
// // 		moduleId: 'invoice',
// // 		name: 'Invoice',
// // 		path: '/invoice',
// // 		icon: <Icon as={HiOutlineDocumentReport} w='20px' h='20px' />,
// // 	},

// // 	// -------- Expenses --------

// // 	{
// // 		moduleId: 'expense',
// // 		name: 'Expenses',
// // 		path: '/expenses',
// // 		icon: <Icon as={FaRegCopy} width='20px' height='20px' color='inherit' />,
// // 	},

// // 	// -------- Tasks --------
// // 	{
// // 		moduleId: 'task',
// // 		name: 'Task',
// // 		path: '/task',
// // 		icon: <Icon as={FaTasks} w='20px' h='20px' />,
// // 	},

// // 	// -------- Listing --------
// // 	{
// // 		moduleId: 'listing',
// // 		name: 'Listing',
// // 		path: '/listing',
// // 		icon: <Icon as={FaList} w='20px' h='20px' />,
// // 		children: [
// // 			{
// // 				name: 'All Listings',
// // 				path: '/listing/all-listings',
// // 			},
// // 			{
// // 				name: 'My Listings',
// // 				path: '/listing/my-listings',
// // 			},
// // 			{
// // 				name: 'Pendings Listing',
// // 				path: '/listing/pending-listing',
// // 			},
// // 			{
// // 				name: 'Pending View Request',
// // 				path: '/listing/pending-view-listing',
// // 			},
// // 			{
// // 				name: 'Approved View Request',
// // 				path: '/listing/approved-view-listing',
// // 			},
// // 			{
// // 				name: 'Rejected View Request',
// // 				path: '/listing/reject-view-listing',
// // 			},

// // 			{
// // 				name: 'Listing Setting',
// // 				path: '/listing/settings',
// // 			},
// // 		],
// // 	},

// // 	// -------- Survey --------
// // 	{
// // 		moduleId: 'survey',
// // 		name: 'Survey',
// // 		path: '/survey',
// // 		icon: <Icon as={FaSquarePlus} w='20px' h='20px' />,
// // 	},

// // 	{
// // 		moduleId: 'sip',
// // 		name: 'Call Logs',
// // 		path: '/sip',
// // 		icon: <Icon as={FaPhone} w='20px' h='20px' />,
// // 		children: [
// // 			{
// // 				name: 'Dashboard',
// // 				path: '/sip/dashboard',
// // 			},
// // 			{
// // 				id: 'call_history',
// // 				name: 'Call History',
// // 				path: '/sip/history',
// // 			},
// // 			{
// // 				id: 'user_analytics',
// // 				name: 'User Analytics',
// // 				path: '/sip/user-analytics',
// // 			},
// // 			{
// // 				id: 'user_settings',
// // 				name: 'User Settings',
// // 				path: '/sip/settings',
// // 			},
// // 			{
// // 				id: 'shared_recordings',
// // 				name: 'Shared Recording',
// // 				path: '/sip/shared-recording',
// // 			},
// // 		],
// // 	},

// // 	// -------- Reports --------
// // 	{
// // 		moduleId: 'reports',
// // 		name: 'Reports',
// // 		path: '/reporting-analytics',
// // 		icon: <Icon as={MdInsertChartOutlined} w='20px' h='20px' />,
// // 	},

// // 	{
// // 		moduleId: 'whatsapp',
// // 		name: 'Whatsapp',
// // 		path: '/whatsapp',
// // 		icon: <Icon as={FaWhatsapp} width='20px' height='20px' color='inherit' />,
// // 		children: [
// // 			{
// // 				id: 'whatsapp_chats',
// // 				name: 'Chats',
// // 				path: '/whatsapp/chats',
// // 			},
// // 			{
// // 				id: 'whatsapp_beta',
// // 				name: 'WhatsApp',
// // 				version: 'Beta',
// // 				path: '/whatsapp/instances',
// // 			},
// // 			{
// // 				id: 'whatsapp_campaigns',
// // 				name: 'Whatsapp Campaigns',
// // 				path: '/whatsapp/bulk-messages',
// // 			},
// // 			{
// // 				id: 'whatsapp_settings',
// // 				name: 'Settings',
// // 				path: '/whatsapp/settings',
// // 			},
// // 		],
// // 	},

// // 	// -------- Users --------
// // 	{
// // 		moduleId: 'users',
// // 		name: 'Users',
// // 		path: '/user',
// // 		icon: <Icon as={HiUsers} w='20px' h='20px' />,
// // 	},

// // 	// -------- System Log --------
// // 	{
// // 		moduleId: 'system_log',
// // 		name: 'System Log',
// // 		path: '/system-log',
// // 		icon: <Icon as={MdOutlineLaptopMac} w='20px' h='20px' />,
// // 	},
// // ];

// export const sidebarRoutes = [
//   // -------- Dashboard --------
//   {
//     name: "Dashboard",
//     path: "/default",
//     icon: MdHome,
//     isNested: false,
//     color: "#6366F1", // Indigo
//   },

//   // -------- Leads --------
//   {
//     moduleId: "leads",
//     name: "Lead",
//     path: "/lead",
//     icon: MdLeaderboard,
//     isNested: true,
//     color: "#9333EA", // Emerald
//     children: [
//       {
//         // id: "leads",
//         name: "Leads",
//         path: "/lead",
//       },
//       {
//         id: "lead_analytics",
//         name: "Analytics",
//         path: "/lead_analytics",
//         version: "Beta",
//       },
//       {
//         id: "call_feedbacks",
//         name: "Call Feedback",
//         path: "/call-feedback",
//       },
//       {
//         // id: "leads_setting",
//         name: "Settings",
//         path: "/lead_settings",
//       },
//     ],
//   },
//   {
//     moduleId: "leadpool_admin",
//     name: "Lead Pool",
//     path: "/pool",
//     isNested: false,
//     icon: MdOutlineAdminPanelSettings,
//     color: "#F59E0B", // Amber
//   },
//   {
//     moduleId: "leadpool_agents",
//     name: "Lead Pool",
//     path: "/agent_pool",
//     isNested: false,
//     icon: MdPeopleOutline,
//     color: "#FBBF24", // Yellow
//   },

//   // -------- Deals --------
//   {
//     moduleId: "deal",
//     name: "Deals",
//     path: "/deals",
//     icon: FaHandshake,
//     isNested: true,
//     color: "#22C55E", // Green
//     children: [
//       {
//         id: "closed_deals",
//         name: "Close Deals",
//         path: "/deals/close-deal",
//       },
//       {
//         id: "shared_deals",
//         name: "Shared Deals",
//         path: "/deals/shared-deals",
//       },
//     ],
//   },

//   // ------- Announcement ------
//   {
//     moduleId: "announcement",
//     name: "Announcement",
//     path: "/announcements",
//     icon: MdCampaign,
//     isNested: true,
//     color: "#EC4899", // Pink
//     children: [
//       {
//         id: "create",
//         name: "Announcement",
//         path: "/announcement/create",
//       },
//       {
//         name: "History",
//         path: "/announcement/history",
//       },
//     ],
//   },

//   // -------- Hiring --------
//   {
//     moduleId: "hiring",
//     name: "Hiring",
//     path: "/hiring",
//     isNested: true,
//     icon: FaClipboardUser,
//     color: "#0EA5E9", // Sky
//     children: [
//       {
//         name: "Dashboard",
//         path: "/hiring/dasboard",
//       },
//       {
//         name: "Candidates",
//         path: "/hiring/candidates",
//       },
//       {
//         name: "Short Listed",
//         path: "/hiring/short-listed",
//       },
//       {
//         name: "Multi-Round",
//         path: "/hiring/multi-round",
//       },
//       {
//         name: "Interviewed Candidates",
//         path: "/hiring/interviewed-candidates",
//       },
//       {
//         name: "Settings",
//         path: "/hiring/settings",
//       },
//     ],
//   },

//   // -------- Attendance --------
//   {
//     moduleId: "attendance",
//     name: "Attendance",
//     path: "/attendance",
//     isNested: true,
//     icon: FaRegCalendarCheck,
//     color: "#A855F7", // Violet
//     children: [
//       {
//         id: "dashboard",
//         name: "Dashboard",
//         path: "/attendance/dashboard",
//       },
//       {
//         id: "employees",
//         name: "Employees",
//         path: "/attendance/employees",
//       },
//       {
//         id: "record",
//         name: "Record",
//         path: "/attendance/record",
//       },
//       {
//         id: "my_attendance",
//         name: "My Attendence",
//         path: "/attendance/my_attendance",
//       },
//     ],
//   },

//   // -------- Invoices --------
//   {
//     moduleId: "invoice",
//     name: "Invoice",
//     path: "/invoice",
//     isNested: true,
//     icon: HiOutlineDocumentReport,
//     color: "#3B82F6", // Blue
//     children: [
//       {
//         name: "Bank Accounts",
//         path: "/invoice/bank-account",
//       },
//       {
//         name: "Developer",
//         path: "/invoice/developer",
//       },
//       {
//         name: "Project",
//         path: "/invoice/project",
//       },
//     ],
//   },

//   // -------- Expenses --------
//   // {
//   // 	moduleId: 'expense',
//   // 	name: 'Expenses',
//   // 	path: '/expenses',
//   // 	isNested: true,
//   // 	icon: FaRegCopy,
//   // 	color: '#F97316', // Orange
//   // 	children: [
//   // 		{
//   // 			name: 'Balance',
//   // 			path: '/expenses/balance',
//   // 		},
//   // 		{
//   // 			name: 'Outgoing Cash',
//   // 			path: '/expenses/outgoing-cash',
//   // 		},
//   // 	],
//   // },

//   // -------- Finance --------
//   {
//     moduleId: "expense",
//     name: "Expenses",
//     path: "/finance",
//     isNested: true,
//     icon: FaRegCopy,
//     color: "#F97316", // Orange
//     children: [
//       {
//         id: "incoming_cash",
//         name: "Incomming Cash",
//         path: "/finance/incoming-cash",
//       },
//       {
//         id: "outgoing_cash",
//         name: "Outgoing Cash",
//         path: "/finance/outgoing-cash",
//       },
//       {
//         id: "employee_loans",
//         name: "Employee Loans",
//         path: "/finance/employee-loans",
//       },
//       {
//         id: "settings",
//         name: "Settings",
//         path: "/finance/settings",
//       },
//     ],
//   },

//   // ------- Evaluation ---------
//   {
//     moduleId: "evaluation",
//     name: "Evaluation",
//     path: "/evaluation",
//     icon: FaFileAlt,
//     color: "#86f17dff", // Gray
//     children: [
//       {
//         id: "evaluation_users",
//         name: "Evalute User",
//         path: "/evaluation/user-evaluation",
//       },
//       {
//         id: "my_evaluations",
//         name: "My Evaluation",
//         path: "/evaluation/my-evaluation",
//       },
//       {
//         id: "settings",
//         name: "Settings",
//         path: "/evaluation/settings",
//       },
//     ],
//   },

//   // ---------- Payroll -----------
//   {
//     moduleId: "payroll",
//     name: "Payroll",
//     path: "/payroll",
//     icon: MdOutlinePayments,
//     // icon: FaMoneyCheckAlt,
//     isNested: false,
//     color: "#36ce6dff", // Teal
//     children: [
//       {
//         // id: 'all_users',
//         name: "Salaried Users",
//         path: "/payroll/users",
//       },
//       {
//         // id: 'commission_users',
//         name: "Commission Users",
//         path: "/payroll/commission-users",
//       },
//     ],
//   },

//   // -------- Tasks --------
//   {
//     moduleId: "task",
//     name: "Task",
//     path: "/task",
//     icon: FaTasks,
//     isNested: false,
//     color: "#14B8A6", // Teal
//   },

//   // -------- Listing --------
//   {
//     moduleId: "listing",
//     name: "Listing",
//     path: "/listing",
//     icon: FaList,
//     isNested: true,

//     color: "#64748B", // Slate
//     children: [
//       {
//         id: "client_listing",
//         name: "Client Listings",
//         path: "/listing/client-listings",
//       },
//       {
//         id: "all_listing",
//         name: "All Listings",
//         path: "/listing/all-listings",
//       },
//       {
//         id: "my_listing",
//         name: "My Listings",
//         path: "/listing/my-listings",
//       },
//       {
//         id: "pending_listing",
//         name: "Pendings Listing",
//         path: "/listing/pending-listing",
//       },
//       {
//         id: "view_requests",
//         name: "View Requests",
//         path: "/listing/view-request-listing",
//       },
//       {
//         id: "settings",
//         name: "Listing Setting",
//         path: "/listing/settings",
//       },
//     ],
//   },

//   // -------- Survey --------
//   {
//     moduleId: "survey",
//     name: "Survey",
//     path: "/survey",
//     isNested: true,
//     icon: FaSquarePlus,
//     color: "#8B5CF6", // Violet
//     children: [
//       {
//         name: "Dashboard",
//         path: "/survey/dashboard",
//       },
//       {
//         name: "All Surveys",
//         path: "/survey/all-surveys",
//       },
//       { id: "create", name: "Create Survey", path: "/survey/create" },
//     ],
//   },

//   // -------- Call Logs (SIP) --------
//   {
//     moduleId: "sip",
//     name: "Call Logs",
//     path: "/sip",
//     isNested: true,
//     icon: FaPhone,
//     color: "#06B6D4", // Cyan
//     children: [
//       { name: "Dashboard", path: "/sip/dashboard" },
//       { id: "call_history", name: "Call History", path: "/sip/history" },
//       {
//         id: "user_analytics",
//         name: "User Analytics",
//         path: "/sip/user-analytics",
//       },
//       { id: "user_settings", name: "Call Settings", path: "/sip/settings" },
//       {
//         id: "shared_recordings",
//         name: "Shared Recording",
//         path: "/sip/shared-recording",
//       },
//     ],
//   },

//   // -------- Reports --------
//   {
//     moduleId: "reports",
//     name: "Reports",
//     isNested: false,
//     path: "/reporting-analytics",
//     icon: MdInsertChartOutlined,
//     color: "#2e6f77ff", // Lime
//   },

//   // -------- Whatsapp --------
//   {
//     moduleId: "whatsapp",
//     name: "Whatsapp",
//     path: "/whatsapp",
//     isNested: true,
//     icon: FaWhatsapp,
//     color: "#25D366", // WhatsApp Green
//     children: [
//       {
//         id: "whatsapp_chats",
//         name: "Chats",
//         path: "/whatsapp/chats",
//       },
//       {
//         id: "whatsapp_beta",
//         name: "WhatsApp",
//         version: "Beta",
//         path: "/whatsapp/instances",
//       },
//       {
//         id: "whatsapp_campaigns",
//         name: "Whatsapp Campaigns",
//         path: "/whatsapp/bulk-messages",
//       },
//       {
//         id: "whatsapp_settings",
//         name: "Settings",
//         path: "/whatsapp/settings",
//       },
//     ],
//   },

//   // -------- Users --------
//   // {
//   // 	moduleId: 'users',
//   // 	name: 'Users',
//   // 	isNested: false,
//   // 	path: '/users',
//   // 	icon: HiUsers,
//   // 	color: '#8B5CF6', // Violet
//   // },

//   // -------- Users V2 --------
//   {
//     moduleId: "users",
//     name: "Users",
//     isNested: false,
//     path: "/users-v2",
//     icon: HiUsers,
//     color: "#8B5CF6", // Violet
//   },

//   // -------- System Log --------
//   {
//     moduleId: "system_log",
//     name: "System Log",
//     path: "/system-log",
//     isNested: false,
//     icon: MdOutlineLaptopMac,
//     color: "#c03910ff", // Gray
//   },
// ];

// export default sidebarRoutes;

import {
  MdHome,
  MdLeaderboard,
  MdOutlineLaptopMac,
  MdInsertChartOutlined,
  MdOutlineAdminPanelSettings,
  MdCampaign,
  MdOutlinePayments,
  MdShoppingCart,
  MdAddShoppingCart,
} from "react-icons/md";
import {
  FaTasks,
  FaRegCalendarCheck,
  FaList,
  FaWhatsapp,
  FaHandshake,
  FaPhone,
  FaRegCopy,
  FaChartLine,
  FaBullhorn,
  FaMoneyBillWave,
  FaUserTie,
  FaBuilding,
  FaChartPie,
  FaClock,
  FaFileInvoice,
  FaReceipt,
  FaRegCalendarPlus,
  FaComments,
  FaMicrophoneAlt,
  FaStar,
  FaShieldAlt,
  FaHistory,
  FaUserCheck,
  FaBriefcase,
  FaLayerGroup,
  FaDatabase,
  FaRobot,
  FaTruck,
  FaPercentage,
} from "react-icons/fa";
import { HiUsers } from "react-icons/hi";
import { FaClipboardUser, FaSquarePlus } from "react-icons/fa6";
import { FaFileAlt, FaBook, FaListUl, FaLandmark, FaFileInvoiceDollar, FaMoneyCheckAlt, FaBullseye, FaClipboardCheck, FaCalendarAlt, FaGlobe, FaLock, FaFileUpload, FaThLarge, FaExclamationTriangle } from "react-icons/fa";
import {
  GiCommercialAirplane,
  GiPayMoney,
  GiTakeMyMoney,
  GiMoneyStack,
} from "react-icons/gi";
import {
  BsGraphUp,
  BsPeople,
  BsChatDots,
  BsCalendarCheck,
  BsFileText,
  BsBarChart,
  BsClipboardData,
  BsGear,
} from "react-icons/bs";
import {
  RiUserSearchLine,
  RiUserStarLine,
  RiUserSettingsLine,
  RiGroupLine,
  RiBillLine,
  RiBankLine,
  RiMoneyDollarCircleLine,
  RiExchangeLine,
  RiListCheck,
  RiChatHistoryLine,
  RiMegaphoneLine,
  RiSurveyLine,
  RiFeedbackLine,
  RiListCheck2,
  RiSettings4Line,
  RiSparklingLine,
  RiFileList3Line,
  RiFileChartLine,
  RiBarChartGroupedLine,
  RiWhatsappLine,
} from "react-icons/ri";
import { SiGoogleanalytics, SiGooglemeet, SiGooglechat } from "react-icons/si";
import {
  TbReportAnalytics,
  TbBuildingEstate,
  TbFileAnalytics,
  TbCalendarStats,
  TbListDetails,
} from "react-icons/tb";
import { IoPeopleOutline, IoDocumentTextOutline } from "react-icons/io5";
import { GrUserAdmin } from "react-icons/gr";

export const sidebarRoutes = [
  // {
  //   name: "Dashboard",
  //   path: "/default",
  //   icon: MdHome,
  //   color: "#6366F1",
  //   isNested: false,
  // },
  {
    name: "Dashboard",
    path: "/default",
    icon: MdHome,
    color: "#6366F1",
    isNested: false,
  },

  // ========================== CRM (SALES) ==========================
  {
    category: "CRM (SALES)",
    routes: [
      {
        moduleId: "leads",
        name: "Leads",
        path: "/lead",
        icon: RiUserSearchLine,
        color: "#9333EA",
        isNested: true,
        children: [
          { name: "Leads", path: "/lead", icon: RiUserSearchLine },
          // {
          //   id: "fresh_leads",
          //   name: 'Fresh Leads',
          //   path: '/fresh-leads',
          //   icon: RiSparklingLine
          // },
          {
            id: "lead_analytics",
            name: "Analytics",
            path: "/lead_analytics",
            icon: BsGraphUp,
          },
          {
            id: "call_feedbacks",
            name: "Call Feedback",
            path: "/call-feedback",
            icon: FaMicrophoneAlt,
          },
          {
            id: "lead_settings",
            name: "Settings",
            path: "/lead_settings",
          },
        ],
      },
      {
        moduleId: "leadpool_admin",
        name: "Lead Pool",
        path: "/pool",
        icon: GrUserAdmin,
        color: "#b7f50bff",
        isNested: false,
      },
      {
        moduleId: "leadpool_agents",
        name: "Lead Pool",
        path: "/agent_pool",
        icon: RiUserStarLine,
        color: "#FBBF24",
        isNested: false,
      },
      {
        moduleId: "buy_new_leads",
        name: "Buy New Leads",
        path: '/buy-new-leads',
        icon: MdAddShoppingCart,
        color: "#19edc9",
        isNested: false,
      },
      {
        moduleId: "deal",
        name: "Deals",
        path: "/deals",
        icon: FaHandshake,
        color: "#1bd15eff",
        isNested: true,
        children: [
          {
            id: "closed_deals",
            name: "Close Deals",
            path: "/deals/close-deal",
            icon: GiPayMoney,
          },
          {
            id: "shared_deals",
            name: "Shared Deals",
            path: "/deals/shared-deals",
            icon: BsPeople,
          },
        ],
      },
    ],
  },

  // ========================== HR MANAGEMENT ==========================
  {
    category: "HR MANAGEMENT",
    routes: [
      {
        moduleId: "hiring",
        name: "Hiring",
        path: "/hiring",
        icon: FaClipboardUser,
        color: "#0EA5E9",
        isNested: true,
        children: [
          { name: "Dashboard", path: "/hiring/dasboard", icon: BsBarChart },
          {
            name: "Candidates",
            path: "/hiring/candidates",
            icon: RiUserSearchLine,
          },
          {
            name: "Short Listed",
            path: "/hiring/short-listed",
            icon: RiUserStarLine,
          },
          {
            name: "Multi Round",
            path: "/hiring/multi-round",
            icon: FaLayerGroup,
          },
          {
            name: "Interviewed Candidates",
            path: "/hiring/interviewed-candidates",
            icon: RiGroupLine,
          },
          { name: "Settings", path: "/hiring/settings", icon: BsGear },
        ],
      },
      {
        moduleId: "attendance",
        name: "Attendance",
        path: "/attendance",
        icon: BsCalendarCheck,
        color: "#A855F7",
        isNested: true,
        children: [
          {
            id: "dashboard",
            name: "Dashboard",
            path: "/attendance/dashboard",
            icon: TbCalendarStats,
          },
          {
            id: "employees",
            name: "Employees",
            path: "/attendance/employees",
            icon: IoPeopleOutline,
          },
          {
            id: "record",
            name: "Record",
            path: "/attendance/record",
            icon: FaClock,
          },
          {
            id: "my_attendance",
            name: "My Attendance",
            path: "/attendance/my_attendance",
            icon: FaUserCheck,
          },
        ],
      },
      {
        moduleId: 'leave',
        name: 'Leave Management',
        path: '/leave-management',
        icon: FaRegCalendarPlus,
        isNested: false,
        version: 'Beta',
        color: '#0EA5E9',
      },
      {
        moduleId: "payroll",
        name: "Payroll",
        path: "/payroll",
        icon: MdOutlinePayments,
        color: "#36ce6dff",
        isNested: true,
        children: [
          {
            id: "salaried_users",
            name: "Salaried Users",
            path: "/payroll/users",
            icon: RiGroupLine,
          },
          {
            id: "commission_users",
            name: "Commission Users",
            path: "/payroll/commission-users",
            icon: RiUserStarLine,
          },
          {
            id: "my_payslip",
            name: "My Payslip",
            path: "/payroll/my-payslip",
            icon: RiFileList3Line,
          },
        ],
      },
    ],
  },

  // ========================== FINANCE ==========================
  {
    category: "FINANCE",

    routes: [
      // {
      //        moduleId: "expense",
      //     id: "employee_loans",
      //     name: "Employee Loans",
      //     path: "/employee-loans",
      //     icon: RiBillLine,
      //   },
      {
        moduleId: "invoice",
        name: "Invoice",
        path: "/invoice",
        icon: FaFileInvoice,
        color: "#3B82F6",
        isNested: true,
        children: [
          {
            name: "Bank Accounts",
            path: "/invoice/bank-account",
            icon: RiBankLine,
          },
          { name: "Developer", path: "/invoice/developer", icon: FaBuilding },
          { name: "Project", path: "/invoice/project", icon: TbBuildingEstate },
          { id: "view", name: "All Invoices", path: "/invoice/all-invoices", icon: FaListUl },
          { id: "manual.view", name: "Manual Invoices", path: "/invoice/manual-invoices", icon: FaFileInvoiceDollar },
          { id: "settings.view", name: "Settings", path: "/invoice/settings", icon: RiSettings4Line },
        ],
      },
      {
        moduleId: "expense",
        name: "Expenses",
        path: "/finance",
        icon: FaReceipt,
        color: "#c2460cff",
        isNested: true,
        children: [
          {
            id: "incoming_cash",
            name: "Incoming Cash",
            path: "/finance/incoming-cash",
            icon: RiMoneyDollarCircleLine,
          },
          {
            id: "outgoing_cash",
            name: "Outgoing Cash",
            path: "/finance/outgoing-cash",
            icon: GiTakeMyMoney,
          },

          {
            id: "settings",
            name: "Settings",
            path: "/finance/settings",
            icon: BsGear,
          },
        ],
      },
      {
        moduleId: "employee_loans",
        name: "Employee Loans",
        path: "/employee-loans",
        icon: RiBillLine,
        color: "#f8b626ff",
        isNested: false, // No children
      },
      {
        moduleId: "finance_core",
        name: "Finance Core",
        path: "/finance-core",
        version: "Beta",
        icon: FaLandmark,
        color: "#10B981",
        isNested: true,
        children: [
          {
            // First, because it is the landing point: whichever role dashboard
            // the user's own permissions can fill. Visibility follows the
            // `finance_dashboard_view` action, not the user's role name.
            id: "finance_dashboard_view",
            name: "Dashboards",
            path: "/finance-core/dashboards",
            icon: FaThLarge,
          },
          {
            id: "chart_accounts_view",
            name: "Chart of Accounts",
            path: "/finance-core/chart-of-accounts",
            icon: FaListUl,
          },
          {
            id: "journal_entries_view",
            name: "Journal Entries",
            path: "/finance-core/journal-entries",
            icon: FaBook,
          },
          {
            id: "invoices_view",
            name: "Developer Invoices",
            path: "/finance-core/developer-invoices",
            icon: FaFileInvoiceDollar,
          },
          {
            id: "collections_view",
            name: "Collections",
            path: "/finance-core/collections",
            icon: FaMoneyBillWave,
          },
          {
            id: "cheques_manage",
            name: "Cheques",
            path: "/finance-core/cheques",
            icon: FaMoneyCheckAlt,
          },
          {
            id: "reports_finance_view",
            name: "Receivables Aging",
            path: "/finance-core/receivables",
            icon: FaChartPie,
          },
          {
            id: "commissions_view",
            name: "Commission Center",
            path: "/finance-core/commissions",
            icon: FaUserTie,
          },
          {
            id: "commissions_view",
            name: "Commission Batches",
            path: "/finance-core/commission-batches",
            icon: FaLayerGroup,
          },
          {
            id: "reports_finance_view",
            name: "Commission Report",
            path: "/finance-core/commission-report",
            icon: FaChartPie,
          },
          {
            id: "expenses_view",
            name: "Expenses",
            path: "/finance-core/expenses",
            icon: FaReceipt,
          },
          {
            id: "suppliers_view",
            name: "Suppliers",
            path: "/finance-core/suppliers",
            icon: FaTruck,
          },
          {
            id: "purchase_requests_view",
            name: "Procurement",
            path: "/finance-core/purchase-requests",
            icon: MdShoppingCart,
          },
          {
            id: "purchase_orders_view",
            name: "Purchase Orders",
            path: "/finance-core/purchase-orders",
            icon: FaFileInvoice,
          },
          {
            id: "ap_invoices_view",
            name: "Supplier Invoices",
            path: "/finance-core/ap-invoices",
            icon: FaFileAlt,
          },
          {
            id: "payments_out_view",
            name: "Payments Out",
            path: "/finance-core/payment-vouchers",
            icon: MdOutlinePayments,
          },
          {
            id: "employee_finance_view",
            name: "Employee Finance",
            path: "/finance-core/employee-finance",
            icon: FaUserCheck,
          },
          {
            id: "payroll_postings_view",
            name: "Payroll Postings",
            path: "/finance-core/payroll-postings",
            icon: FaBriefcase,
          },
          {
            id: "treasury_view",
            name: "Treasury",
            path: "/finance-core/treasury",
            icon: FaMoneyBillWave,
          },
          {
            id: "treasury_view",
            name: "Bank",
            path: "/finance-core/bank",
            icon: FaLandmark,
          },
          {
            id: "cards_view",
            name: "Corporate Cards",
            path: "/finance-core/cards",
            icon: FaMoneyCheckAlt,
          },
          {
            id: "obligations_view",
            name: "Obligations",
            path: "/finance-core/obligations",
            icon: FaFileInvoiceDollar,
          },
          {
            id: "contracts_view",
            name: "Contracts",
            path: "/finance-core/contracts",
            icon: FaHandshake,
          },
          {
            id: "treasury_view",
            name: "Treasury Reports",
            path: "/finance-core/treasury-reports",
            icon: FaBook,
          },
          {
            id: "recognition_view",
            name: "Recognition",
            path: "/finance-core/recognitions",
            icon: FaLayerGroup,
          },
          {
            id: "assets_view",
            name: "Fixed Assets",
            path: "/finance-core/assets",
            icon: FaDatabase,
          },
          {
            id: "inventory_view",
            name: "Inventory",
            path: "/finance-core/inventory",
            icon: FaTruck,
          },
          {
            id: "assets_view",
            name: "Asset Reports",
            path: "/finance-core/asset-reports",
            icon: FaFileAlt,
          },
          {
            id: "allocations_view",
            name: "Cost Allocation",
            path: "/finance-core/allocations",
            icon: FaLayerGroup,
          },
          {
            id: "allocations_view",
            name: "Projects",
            path: "/finance-core/projects",
            icon: FaBriefcase,
          },
          {
            id: "equity_view",
            name: "Equity",
            path: "/finance-core/equity",
            icon: FaHandshake,
          },
          {
            id: "credit_view",
            name: "Credit Control",
            path: "/finance-core/credit-control",
            icon: FaShieldAlt,
          },
          {
            id: "tax_view",
            name: "Tax",
            path: "/finance-core/tax-codes",
            icon: FaPercentage,
          },
          {
            id: "tax_view",
            name: "Tax Returns",
            path: "/finance-core/tax-returns",
            icon: FaFileInvoiceDollar,
          },
          {
            id: "fx_view",
            name: "Currency",
            path: "/finance-core/currency",
            icon: FaGlobe,
          },
          {
            id: "periods_manage",
            name: "Period Close",
            path: "/finance-core/period-close",
            icon: FaLock,
          },
          {
            id: "imports_run",
            name: "Imports",
            path: "/finance-core/imports",
            icon: FaFileUpload,
          },
          {
            id: "reports_finance_view",
            name: "Profitability",
            path: "/finance-core/profitability",
            icon: FaChartPie,
          },
          {
            id: "finance_dashboard_view",
            name: "Costing & Performance",
            path: "/finance-core/costing-dashboard",
            icon: FaChartLine,
          },
          {
            id: "reports_finance_view",
            name: "Financial Reports",
            path: "/finance-core/financial-reports",
            icon: FaFileAlt,
          },
          {
            id: "reports_finance_view",
            name: "Budgets",
            path: "/finance-core/budgets",
            icon: FaBullseye,
          },
          {
            id: "approvals_view",
            name: "Approvals",
            path: "/finance-core/approvals",
            icon: FaClipboardCheck,
          },
          {
            id: "finance_dashboard_view",
            name: "Financial Calendar",
            path: "/finance-core/calendar",
            icon: FaCalendarAlt,
          },
          {
            id: "settings_manage",
            name: "Finance Governance",
            path: "/finance-core/governance",
            icon: FaShieldAlt,
          },
          {
            id: "risk_view",
            name: "Risk & Controls",
            path: "/finance-core/risk",
            icon: FaExclamationTriangle,
          },
        ],
      },

    ],
  },

  // ========================== OPERATIONS ==========================
  {
    category: "OPERATIONS",
    routes: [
      {
        moduleId: "task",
        name: "Task",
        path: "/task",
        icon: FaTasks,
        color: "#14B8A6",
        isNested: false,
      },
      {
        moduleId: "listing",
        name: "Listing",
        path: "/listing",
        icon: TbListDetails,
        color: "#64748B",
        isNested: true,
        children: [
          {
            id: "client_listing",
            name: "Client Listings",
            path: "/listing/client-listings",
            icon: FaBriefcase,
          },
          {
            id: "all_listing",
            name: "All Listings",
            path: "/listing/all-listings",
            icon: FaList,
          },
          {
            id: "my_listing",
            name: "My Listings",
            path: "/listing/my-listings",
            icon: IoDocumentTextOutline,
          },
          {
            id: "pending_listing",
            name: "Pending Listings",
            path: "/listing/pending-listing",
            icon: FaClock,
          },
          {
            id: "view_requests",
            name: "View Requests",
            path: "/listing/view-request-listing",
            icon: RiExchangeLine,
          },
          {
            id: "settings",
            name: "Settings",
            path: "/listing/settings",
            icon: BsGear,
          },
        ],
      },
    ],
  },

  // ========================== COMMUNICATION ==========================
  {
    category: "COMMUNICATION",
    routes: [
      {
        name: 'AI Assistance',
        path: 'dev-intel',
        moduleId: 'devintel',
        icon: FaRobot,
        // permission: 'devintel:read',
        isNested: true,
        color: '#13af3aff',
        children: [
          {
            name: 'Inbox',
            path: '/admin/dev-intel/inbox',
            id: 'devintel_inbox',
          },
          {
            name: 'Projects',
            path: '/admin/dev-intel/projects',
            id: 'devintel_projects',
          },
          {
            name: 'Ask AI',
            path: '/admin/dev-intel/ask',
            id: 'devintel_ask',
          },
        ],
      },
      {
        moduleId: "whatsapp",
        name: "WhatsApp",
        path: "/whatsapp",
        icon: FaWhatsapp,
        color: "#25D366",
        isNested: true,
        children: [
          {
            id: "whatsapp_chats",
            name: "Chats",
            path: "/whatsapp/chats",
            icon: BsChatDots,
          },
          {
            id: "whatsapp_beta",
            name: "Instances",
            version: "Beta",
            path: "/whatsapp/instances",
            icon: FaDatabase,
          },
          {
            id: "whatsapp_campaigns",
            name: "Campaign",
            path: "/whatsapp/bulk-messages",
            icon: RiMegaphoneLine,
          },
          {
            // Gated like its sibling "Campaign". An id-less child is checked at
            // MODULE level, and now that a Meta-only role must enable the
            // `whatsapp` module, it would otherwise surface for agents who hold
            // no classic campaign grant at all.
            id: "whatsapp_campaigns",
            name: 'Campaign History',
            path: '/whatsapp/campaigns',
          },
          {
            // Meta WhatsApp V2 lives INSIDE the WhatsApp group — and inside the
            // `whatsapp` permission module, as its `inbox.view` action. It ships
            // DENIED, so this appears for nobody until granted.
            id: "inbox.view",
            name: "Meta WhatsApp",
            version: "Beta",
            path: "/meta-whatsapp",
            icon: RiWhatsappLine,
          },
          {
            // The campaign engine. Carries its own `id`, so it is checked at
            // ACTION level and stays invisible until somebody is granted
            // `campaign.view` — an id-less entry would be checked at module
            // level and appear for every agent who has an inbox.
            id: "campaign.view",
            name: "Meta Campaigns",
            version: "Beta",
            path: "/meta-campaigns",
            icon: RiMegaphoneLine,
          },
          {
            // One settings page, two tabs (classic + Meta). Reachable by anyone
            // who holds EITHER tab's permission; the page shows only the tabs
            // they hold.
            id: "whatsapp_settings",
            anyOf: [
              ["whatsapp", "whatsapp_settings"],
              ["whatsapp", "settings.view"],
            ],
            name: "Settings",
            path: "/whatsapp/settings",
            icon: RiSettings4Line,
          },
        ],
      },
      {
        moduleId: "sip",
        name: "Call Logs",
        path: "/sip",
        icon: FaPhone,
        color: "#06B6D4",
        isNested: true,
        children: [
          { name: "Dashboard", path: "/sip/dashboard" },
          {
            id: "voip_analytics",
            name: "Call Analytics",
            path: "/sip/voip-analatics",
          },
          {
            id: "user_analytics",
            name: "User Analytics",
            path: "/sip/user-analytics",
          },
          {
            //  id: 'leaderboard',
            name: "Leaderboard",
            path: "/sip/leaderboard",
          },
          { id: "call_history", name: "Call History", path: "/sip/history" },
          {
            id: "my_recordings",
            name: "My Recordings",
            path: "/sip/my-recordings",
          },


          { id: "user_settings", name: "Call Settings", path: "/sip/settings" },
          {
            id: "shared_recordings",
            name: "Shared Recording",
            path: "/sip/shared-recording",
          },
        ],
      },
      {
        moduleId: "announcement",
        name: "Announcement",
        path: "/announcements",
        icon: MdCampaign,
        color: "#EC4899",
        isNested: true,
        children: [
          {
            id: "create",
            name: "Create",
            path: "/announcement/create",
            icon: FaBullhorn,
          },
          { name: "History", path: "/announcement/history", icon: FaHistory },
        ],
      },
    ],
  },

  // ========================== INSIGHTS & FEEDBACK ==========================
  {
    category: "INSIGHTS & FEEDBACK",
    routes: [
      {
        moduleId: 'reports',
        name: 'Reporting & Analytics',
        isNested: true,
        path: '/reporting-analytics',
        icon: MdInsertChartOutlined,
        color: '#2e6f77ff', // Lime
        children: [
          {
            // Gated under the existing `report` action (not a fresh `insights`
            // action) so the link is visible to everyone who can already see
            // Reports — no re-login/permission refresh required. The sidebar
            // keys children by index, so sharing an id is safe.
            id: 'report',
            name: 'Insights',
            path: '/reporting-analytics/insights',
            icon: RiBarChartGroupedLine
          },
          {
            id: 'report',
            name: 'Reports',
            path: '/reporting-analytics/reports',
            icon: RiFileChartLine
          },
          {
            id: 'advance_reports',
            name: 'Advanced Reports',
            path: '/reporting-analytics/advance-reports',
            icon: RiBarChartGroupedLine
          },
        ],
      },

      {
        moduleId: "survey",
        name: "Survey",
        path: "/survey",
        icon: RiSurveyLine,
        color: "#8B5CF6",
        isNested: true,
        children: [
          { name: "Dashboard", path: "/survey/dashboard", icon: BsGraphUp },
          {
            name: "All Surveys",
            path: "/survey/all-surveys",
            icon: RiSurveyLine,
          },
          {
            id: "create",
            name: "Create Survey",
            path: "/survey/create",
            icon: FaSquarePlus,
          },
        ],
      },
      {
        moduleId: "evaluation",
        name: "Evaluation",
        path: "/evaluation",
        icon: FaFileAlt,
        color: "#86f17dff", // Gray
        isNested: true,
        children: [
          {
            id: "evaluation_users",
            name: "Evalute User",
            path: "/evaluation/user-evaluation",
          },
          {
            id: "my_evaluations",
            name: "My Evaluation",
            path: "/evaluation/my-evaluation",
          },
          {
            id: "settings",
            name: "Settings",
            path: "/evaluation/settings",
          },
        ],
      },
    ],
  },

  // ========================== ADMINISTRATION ==========================
  {
    category: "ADMINISTRATION",
    routes: [
      {
        moduleId: "users",
        name: "Users",
        path: "/users-v2",
        icon: HiUsers,
        color: "#8B5CF6",
        isNested: false,
      },
      {
        moduleId: "system_log",
        name: "System Logs",
        path: "/system-log",
        icon: RiListCheck2,
        color: "#059999ff",
        isNested: false,
      },
    ],
  },
];

export default sidebarRoutes;
